export default "__VITE_ASSET__151921f3__"